import '../../App.css';
import Seo from '../../components/common/atoms/Seo';
import seoData from '../../json/seo.json';
import textData from '../../json/text.json';
import Header from '../../components/menu/organisms/Header';
import Footer from  '../../components/footer/Footer';
import TopicPath from '../../components/common/atoms/TopicPath';
import H1 from '../../components/common/atoms/H1';
import BackgroundAnimation from '../../components/motion/atoms/BackgroundAnimation';
import LogisticsContent from '../../components/service/organisms/LogisticsContent';

/**
 * 物流コンサルティングページ
 * @returns 
 */
function Logistics() {
  const links = [{link:'/logistics', pageName:textData['menu.service.logistics']['ja']}];
  const titleText = textData['menu.service.logistics']['ja'];
  return (

    <div>
      <BackgroundAnimation />
      <Seo title={titleText} description={seoData.pages.logistics.description} path='/logistics' />

      <header>
        <Header />
      </header>
      
      <main className="main-content">
        <TopicPath links={links} />
        <H1 text={titleText}/>
        <LogisticsContent />
      </main>
      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default Logistics;
